const QuestionTypes = {
  INTEGER_VALUE: "integerValue",
  SINGLE_TEXT_VALUE: "singleTextValue",
  MULTIPLE_TEXT_VALUE: "multipleTextValue"
};

QuestionTypes.ALL = Object.values(QuestionTypes);

export default QuestionTypes;
